import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as yup from 'yup'
import {
  faList,
} from '@fortawesome/pro-regular-svg-icons';
import DataTableSectionWithUpload from 'src/components/era-package/forms/DataTableSectionWithUpload';

import AbiEntrySummaryApiUrls from "../../../apiUrls/AbiEntrySummaryApiUrls";
import {hts, htsField} from 'src/views/abi/fields/hts-code';
import Spinner from "../../../components/era-package/era/Spinner";

export const useHtsCodeForm = (data, setData) => {
  const key = 'hts';
  const fileFormat = ['.txt']
  const [loading, setLoading] = useState(true);
  const [filesUnderProcessing, setFilesUnderProcessing] = useState("")

  const handleUploadSuccess = useCallback(() => {
    console.log("Custom post upload logic for duty calculation");
  }, []);

  const fetchData = async () => {
    const response = await fetch(`${AbiEntrySummaryApiUrls.GET_HTS_CODE}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
      },
    });
    const json = await response.json();
    return json.data;
  };

  const handleApiCall = useCallback(async (file, formData, formMethods) => {

    const apiFormData = new FormData();
    apiFormData.append('file', file);

    try {
      const response = await fetch(AbiEntrySummaryApiUrls.UPLOAD_HTS_CODE, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
        body: apiFormData
      });

      if (!response.ok) {
        throw new Error('Error uploading file');
      }

      const result = await response.json();
      console.log('File uploaded successfully:', result);
      setFilesUnderProcessing(file.name);
    } catch (error) {
      throw new Error('Error uploading file');
    }
  }, []);

  const handleRefresh = useCallback(async (rhf) => {
    try {
      setLoading(true);
      const data = await fetchData();
      const items = data?.map(item => ({
        ...item,
        description: item.description.replaceAll('&lt;', '<')
          .replaceAll('&gt;', '>')
          .replaceAll('&amp;', '&')}))

      setData(items);
      setLoading(false);
      rhf.setValue('hts',items)
      return data;
    } catch (error) {
      console.error('Error refreshing line items:', error);
      setLoading(false);
    }
  }, [setData]);

  const handleDeleteRow = useCallback(async (id) => {
    try {

      const response = await fetch(AbiEntrySummaryApiUrls.DELETE_HTS_CODE+`?id=${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
      })

      if (!response.ok) {
        console.log('Error deleting file');
      }
      const result = await response.json();
      console.log('File deleted successfully:', result);
      return result.data;
    } catch (error) {
      console.log('Error deleting file');
    }
  }, []);

  const formSections = useMemo(() => [
    {
      icon: <FontAwesomeIcon icon={faList} />,
      type: 'table', name: `${key}`,
      tableComponent: DataTableSectionWithUpload,
      disableEdit: false,
      tableFields: hts,
      formFields: htsField,
      onUploadSuccess: handleUploadSuccess,
      handleApiCall: handleApiCall,
      handleRefresh: handleRefresh,
      handleDeleteRow: handleDeleteRow,
      filesUnderProcessing: filesUnderProcessing,
      disableAdd: true,
      fileFormat: fileFormat
    }
  ], [handleApiCall, handleUploadSuccess, handleRefresh, handleDeleteRow]);

  return {
    name: key,
    formSections,
    schema: baseObj => yup.array().nullable().default([]),
    handleRefresh,
    loading
  }
}



const HtsCodeFormComponent = () => {
  const rhf = useForm();
  const [data, setData] = useState([]);
  const { formSections, handleRefresh, loading } = useHtsCodeForm(data, setData);


  useEffect(() => {
    const loadData = async () => {
      await handleRefresh(rhf);
    };
    loadData();
  }, [handleRefresh]);


  const columns = [
    ...hts.map(field => {
      return {
        accessorKey: field.name,
        header: field.label,
      };
    }),
  ];

  const handleInput = data => {
    if (!!rhf)
      rhf.setValue(formSections[0].name, data)
    if (!!formSections[0].onTableDataChange)
      formSections[0].onTableDataChange(data)
  }

  return (
    <FormProvider {...rhf}> {}
      <div>
        {loading ? <div style={{ position: 'relative', height: '200px' }}>    <Spinner />  </div> : (
          formSections.map(section => {
            const TableComponent = section.tableComponent;
            return (
              <div key={section.title}>
                <h3>{section.title}</h3>
                <TableComponent
                  title={section.title}
                  fields={section.tableFields}
                  formFields={section.formFields}
                  columns={columns}
                  name={section.name}
                  fileFormat={section.fileFormat}
                  data={data}
                  handleApiCall={section.handleApiCall}
                  handleRefresh={section.handleRefresh}
                  handleClearAll={section.handleClearAll}
                  filesUnderProcessing={section.filesUnderProcessing}
                  onDataChange={handleInput}
                  handleDeleteRow={section.handleDeleteRow}
                  onUploadSuccess={section.onUploadSuccess}
                  uploadFormComponent={section.uploadFormComponent}
                  disableEdit={section.disableEdit}
                  disableAdd={true}
                  useHtsEdit={true}
                  showCustomUploadBtn={true}
                  optionsMap={{}}
                />
              </div>
            );
          })
        )}
      </div>
    </FormProvider>
  );
};

export default HtsCodeFormComponent;
